<template>
    <div class="topbar" v-if="$store.getters.currentUser">
        <a href="#" @click.prevent="signOut" class="topbar__logout">{{$t('menu.signout')}}</a>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';

    @Component()
    export default class Topbar extends Vue {
        name = 'topbar';

        signOut() {
            this.$auth.signOut().then(() => {
                this.$router.go(this.$config.redirects.signout);
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Topbar.vue